/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { GlobalState } from 'src/core/types/GlobalState';

/**
 * A React context to provide the same instance of the dispatcher
 * and store to all components that need them for data access.
 */
export const GlobalStateContext = React.createContext<GlobalState>(null);
